export const narrativeProjects = [
  {
    id: '1',
    title: 'benzinho',
    descriptionKey: 'benzinhoDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/de78dbabd60a760568c1048e3a3f8071.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/251333628&title=BENZINHO'
  },
  {
    id: '2',
    title: 'evidenciasDoAmor',
    descriptionKey: 'evidenciasDoAmorDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/9c0aa24e32903856ca94235d0ead93d0.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091251058&title=EVIDÊNCIAS%20DO%20AMOR'
  },
  {
    id: '3',
    title: 'aWolfAmongSwans',
    descriptionKey: 'aWolfAmongSwansDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/cdd943c772995d8d0fc99610973176fd.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091253573&title=A%20WOLF%20AMONG%20SWANS'
  },
  {
    id: '24',
    title: 'AGENTES MUITO ESPECIAIS',
    descriptionKey: 'agentesMuitoEspeciaisDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/1a70450a46b675f29c70195a7886afbf.jpeg',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1166973885&title=AGENTES%20MUITO%20ESPECIAIS'
  },
  {
    id: '4',
    title: 'MALLANDRO, O ERRADO QUE DEU CERTO',
    descriptionKey: 'mallandroDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/946a5e5933ddaaf8c0b27313c52f7769.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091272681&title=MALLANDRO%2C%20O%20ERRADO%20QUE%20DEU%20CERTO'
  },
  {
    id: '5',
    title: 'DOCE FAMÍLIA',
    descriptionKey: 'doceFamiliaDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/653e3d6427fa853fce6395d2fd4a932d.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091248929&title=DOCE%20FAM%C3%8DLIA&from=narrative'
  },
  {
    id: '6',
    title: 'techBrandCampaign',
    descriptionKey: 'hopefulsDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/f5fa0aab7b0ca52b1be17df811b61801.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//www.youtube.com/watch%3Fv%3DHzVorlLnbnE&title=HOPEFULS&from=narrative'
  },
  {
    id: '7',
    title: 'osUltimosDiasDeGilda',
    descriptionKey: 'osUltimosDiasDeGildaDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/d3acc5b6867fcc8f67af7ce27836d9f3.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091267276&title=OS%20ÚLTIMOS%20DIAS%20DE%20GILDA'
  },
  {
    id: '8',
    title: 'JORGE OF CAPADOCIA',
    descriptionKey: 'jorgeOfCapadociaDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/3c9721fcf6cc86ca101d978c9180a0f0.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091276887&title=JORGE%20OF%20CAPADOCIA'
  },
  {
    id: '11',
    title: 'ESSE AMOR QUE NOS CONSOME',
    descriptionKey: 'esseAmorQueNosConsomeDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/404f6ea7347400caf7a8e0a86e1ffb6e.jfif',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091258021&title=ESSE%20AMOR%20QUE%20NOS%20CONSOME&from=narrative'
  },
  {
    id: '12',
    title: 'RENSGA HITS',
    descriptionKey: 'rensgaHitsDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/5e5d159f21dfba8633cc41cd11b0dd5e.jfif',
    category: 'narrative' as const,
    link: 'https://globoplay.globo.com/v/12824632/?s=33m39s'
  },
  {
    id: '10',
    title: 'FERNANDO',
    descriptionKey: 'fernandoDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/a9baa3f9c3490268bfb4b780548a3e9d.jpeg',
    category: 'narrative' as const,
    link: '/video?id=https%3A//vimeo.com/1091255878&title=FERNANDO'
  }
];

export const commercialProjects = [
  {
    id: '19',
    title: 'Xand Avião e Wesley Safadão // Eu e a Torcida do Brasil',
    descriptionKey: 'xandAviaoDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/bc56c02285e8aa186ca56fad1507be90.jfif',
    category: 'commercial' as const,
    link: '/video?id=https%3A//vimeo.com/280954631&title=Xand%20Avião%20e%20Wesley%20Safadão%20//%20Eu%20e%20a%20Torcida%20do%20Brasil'
  },
  {
    id: '20',
    title: 'Biltre part. Letrux (Clipe Oficial) // Vamos Gozar',
    descriptionKey: 'biltreDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/555abd7444a81fa587141cd658fa6c07.jfif',
    category: 'commercial' as const,
    link: '/video?id=https%3A//vimeo.com/316580987&title=Biltre%20part.%20Letrux%20(Clipe%20Oficial)%20//%20Vamos%20Gozar'
  },
  {
    id: '22',
    title: 'Juan Marcus e Vinícius // Alguns Defeitos',
    descriptionKey: 'juanMarcusDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/877723b8622a5a7a9364f70558af727e.jfif',
    category: 'commercial' as const,
    link: '/video?id=https%3A//vimeo.com/316585633&title=Juan%20Marcus%20e%20Vinícius%20//%20Alguns%20Defeitos'
  },
  {
    id: '23',
    title: 'Leo Santana // 10 Beijos de Rua',
    descriptionKey: 'leoSantanaDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/76002d5c928984cad4a1e3b9eb0de4ae.jfif',
    category: 'commercial' as const,
    link: '/video?id=https%3A//vimeo.com/280950794&title=Leo%20Santana%20//%2010%20Beijos%20de%20Rua'
  }
];

export const documentaryProjects = [
  {
    id: '9',
    title: 'POR UM RESPIRO',
    descriptionKey: 'porUmRespiroDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/3ed1109a7c9d44473d6d8f9a738680cf.jfif',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/1091269291&title=POR%20UM%20RESPIRO'
  },
  {
    id: '21',
    title: 'NÓS DOCUMENTARISTAS',
    descriptionKey: 'nosDocumentaristasDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/710d07ad09dabc8c2d84e29ee0b7f308.jfif',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/316591992&title=NÓS%20DOCUMENTARISTAS'
  },
  {
    id: '25',
    title: 'DAMAS DO SAMBA',
    descriptionKey: 'damasDoSambaDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/efc35eb4021f577ee97788d0691c4cca.jpeg',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/254912516&title=DAMAS%20DO%20SAMBA'
  },
  {
    id: '16',
    title: 'FAUSTO FAWCETT NA CABEÇA',
    descriptionKey: 'faustoFawcettDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/3a7f85640b1f7bd44789399566b42888.jfif',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/1091260177&title=FAUSTO%20FAWCETT%20NA%20CABEÇA'
  },
  {
    id: '17',
    title: 'THE PERFECT STORM',
    descriptionKey: 'perfectStormDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/9e2d111a1ffb1a0e327ef02969a0d176.jfif',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/1091264953&title=THE%20PERFECT%20STORM'
  },
  {
    id: '18',
    title: 'OUTROS TEMPOS',
    descriptionKey: 'outrosTemposDesc',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/f038e5c5e032fab087850549a52395ac.jfif',
    category: 'documentary' as const,
    link: '/video?id=https%3A//vimeo.com/254906276&title=OUTROS%20TEMPOS'
  }
];

export const reelProjects = [
  {
    id: '12',
    title: 'CINEMATOGRAPHY REEL 2012 - 2017',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/130ba2213c13582d9f52e27f3448b02f.jfif',
    category: 'reel' as const,
    link: '/video?id=https%3A//vimeo.com/255785304&title=CINEMATOGRAPHY%20REEL%202012%20-%202017'
  },
  {
    id: '13',
    title: 'CINEMATOGRAPHY REEL 2018-2020',
    image: 'https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/d3acc5b6867fcc8f67af7ce27836d9f3.jfif',
    category: 'reel' as const,
    link: '/video?id=https%3A//vimeo.com/958681866&title=CINEMATOGRAPHY%20REEL%202018-2020'
  }
];

// Update allProjects to exclude the project from home page display
export const allProjects = [...narrativeProjects.filter(p => p.id !== '11'), ...documentaryProjects, ...commercialProjects];
